import { loadStorageControlsData } from '../../../common/utils/load-storage-controls-data';
import { CookieCategory } from '../../../types';
import { getPreferences } from '../../storage-preferences/get-preferences';

export const isThirdPartyAllowed = async (thirdParty: string): Promise<boolean> => {
	/*
    If no preferences for whatever reason, deny
    If prefs exist and are default, they will default to allow/block all based on locale
    If third party has no category for whatever reason or the data doesn't resolve, deny
    If third party has a category, check preferences and allow/deny
  */
	const preferences = await getPreferences();
	if (!preferences) {
		return Promise.resolve(false);
	}

	let shouldDenyThirdParty = false;
	const storageControlsData = await loadStorageControlsData();

	if (storageControlsData) {
		const { thirdPartyKeys, categories } = storageControlsData;

		const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
		const numToCategoryMap = {
			[categories.STRICTLY_NECESSARY]: CookieCategory.StrictlyNecessary,
			[categories.FUNCTIONAL]: CookieCategory.Functional,
			[categories.ANALYTICS]: CookieCategory.Analytics,
			[categories.MARKETING]: CookieCategory.Marketing,
			[categories.UNKNOWN]: CookieCategory.Unknown,
		};

		const thirdPartyCategory =
			thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;

		let hasPreferencesForCategoryType = false;

		if (!!thirdPartyCategory) {
			hasPreferencesForCategoryType = preferences[thirdPartyCategory];
		}
		shouldDenyThirdParty = hasPreferencesForCategoryType;
	}

	return Promise.resolve(shouldDenyThirdParty);
};
